export default "__VITE_ASSET__DKh2SHYR__"